import {
  Box,
  Card,
  CardContent,
  makeStyles,
  Switch,
  Typography
} from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import React from "react";
import { useIntl } from "react-intl";

import { PermissionGroupDetails_permissionGroup } from "../../types/PermissionGroupDetails";
import { PermissionGroupDetailsPageFormData } from "../PermissionGroupDetailsPage/PermissionGroupDetailsPage";

interface PermissionGroup2FAProps {
  data: PermissionGroupDetailsPageFormData;
  isMfaEnabled: boolean;
  permissionGroup: PermissionGroupDetails_permissionGroup;
  handleSwitchChange: () => void;
}

const useStyles = makeStyles(
  {
    root: {
      "& .MuiSwitch-switchBase.Mui-disabled": {
        color: "#FFFFFF"
      },
      "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: "#BEBEBE"
      }
    }
  },
  { name: "PermissionGroup2FA" }
);
const PermissionGroup2FA: React.FC<PermissionGroup2FAProps> = ({
  isMfaEnabled,
  handleSwitchChange,
  permissionGroup
}) => {
  const intl = useIntl();
  const classes = useStyles({});
  const allowedGroupNames = ["OMI Admin", "Ops Master", "OMI Ops"];
  const isAllowedGroup = allowedGroupNames.includes(permissionGroup?.name);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Privacy & Security",
          description: "2FA Dialog Header"
        })}
      />
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography>
            <b>Two-factor Authentication (2FA)</b>
          </Typography>
          <Switch
            checked={isMfaEnabled}
            onChange={handleSwitchChange}
            name="2FA Switch"
            color="primary"
            disabled={!isAllowedGroup}
            className={classes.root}
          />
        </Box>
        <Box
          mt={2}
          bgcolor={isAllowedGroup ? "#F4F8FF" : "#F5F5F5"}
          p={2}
          borderRadius={2}
        >
          <Typography
            variant="body2"
            color={isAllowedGroup ? "primary" : "textSecondary"}
          >
            {isAllowedGroup
              ? "You may need to reconfigure 2FA if you change your email or mobile number."
              : "Two-factor authentication is not available for this user type"}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PermissionGroup2FA;
